<app-header></app-header>

<ion-content scrollbar>
  <div class="bredcrumb-padding-bottom" *ngIf="!p.renderMobile">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ion-grid class="no-padding-grid-box">
    <ion-row justify-content-center>
      <ion-col size="12" size-md="12" size-sm="12" size-lg="12" size-xl="6">
        <form [formGroup]="form">
          <ion-grid class="box">
            <ion-row class="small-padding" justify-content-center>
              <ion-col class="full-width">
                <h1 *ngIf="!p.renderMobile">
                  {{ 'SETTINGS.SETTING' | translate }}
                </h1>
                <app-upload-attachment
                  takePhotoOption="true"
                  [attachment]="user.avatar"
                  avatar="true"
                  [uploadAttachmentButtonText]="translateService.instant('SETTINGS.ADD_PROFILE_PICTURE')"
                  [changeAttachmentButtonText]="translateService.instant('SETTINGS.CHANGE_PROFILE_PICTURE')"
                  (attachmentUploaded)="imageUploaded($event)"
                  (attachmentRemoved)="imageRemoved($event)"
                ></app-upload-attachment>
                <ion-label
                  *ngIf="form.get('itemImage').hasError('fileFormat')"
                  color="danger"
                  class="font-size__16"
                >
                  <div>
                    {{ "FILE_TYPE_VALIDATION_1" | translate }}
                    "{{form.get('itemImage').errors.fileFormat.actualFormat}}".
                    {{ "FILE_TYPE_VALIDATION_2" | translate }}
                  </div>
                </ion-label>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="email"
                  label="SETTINGS.EMAIL"
                  [disabled]="true"
                ></app-input>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="firstName"
                  label="SETTINGS.FIRST_NAME"
                  [disabled]="true"
                ></app-input>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="lastName"
                  label="SETTINGS.LAST_NAME"
                  [disabled]="true"
                ></app-input>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="telephone"
                  label="SETTINGS.TELEPHONE"
                  [submittedError]="validationError"
                ></app-input>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="mobilePhone"
                  label="SETTINGS.MOBILE_PHONE"
                  [submittedError]="validationError"
                ></app-input>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="carPlate"
                  [(ngModel)]="user.carPlate"
                  label="SETTINGS.CAR_PLATE"
                  [submittedError]="validationError"
                ></app-input>

                <div lines="none">
                  <div class="language-input">
                    <ion-label>
                      {{ 'SETTINGS.LANGUAGE' | translate }}
                    </ion-label>
                  </div>
                  <ion-button
                    fill="outline"
                    size="medium"
                    (click)="changeLanguage()"
                  >
                    <ion-icon
                      class="button-icon"
                      src="assets/icons/lang.{{ currentLanguage.value }}.svg"
                      size="large"
                    ></ion-icon>
                    <ion-label class="button-label">
                      {{currentLanguage.name}}
                    </ion-label>
                  </ion-button>
                </div>
                <div class="control-display">
                  <ion-label
                    >{{'ADD_INVITATION.BUILDING' | translate}}</ion-label
                  >
                  <app-select-dropdown
                    *ngIf="languageReloader"
                    formControlName="building"
                    [data]="buildingServ.buildings"
                    (changeValueEvent)="buildingChange($event)"
                  ></app-select-dropdown>
                </div>
                <ion-label
                  *ngIf="form.get('building').hasError('required') && (form.get('building').touched || validationError)"
                  color="danger"
                  class="font-size__16"
                >
                  {{'REQUIRED_VALIDATION' | translate }}
                </ion-label>

                <app-checkbox
                  [slot]="'start'"
                  [form]="form"
                  formControlName="pushAccepted"
                  [checked]="form.controls.pushAccepted.value"
                  label="SETTINGS.PUSH_ACCEPTED"
                ></app-checkbox>

                <div>
                  <ion-item class="input" lines="none">
                    <ion-button
                      class="button-margin-top-md"
                      fill="outline"
                      size="medium"
                      (click)="onChangePasswordButtonClick()"
                    >
                      {{ 'SETTINGS.CHANGE_PASSWORD' | translate }}
                    </ion-button>

                    <ion-button
                      class="button-margin-top-md"
                      (click)="save()"
                      size="medium"
                      slot="end"
                      [disabled]="disableSaveButton"
                    >
                      <ng-container *ngIf="!disableSaveButton"
                        >{{'SAVE' | translate}}</ng-container
                      >
                      <ng-container *ngIf="disableSaveButton"
                        >{{'SAVING' | translate}}</ng-container
                      >
                    </ion-button>
                  </ion-item>
                  <ion-button
                    class="button-margin-top-md"
                    fill="outline"
                    size="medium"
                    (click)="onDeleteAccount()"
                  >
                    <ion-icon name="trash-outline"></ion-icon>
                    {{ 'SETTINGS.DELETE_ACCOUNT' | translate }}
                  </ion-button>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </form>
      </ion-col>

      <ion-col size="12" size-md="12" size-sm="12" size-lg="12" size-xl="6">
        <ion-grid class="box">
          <ion-row class="small-padding" justify-content-center>
            <ion-col class="full-width">
              <div class="ion-text">
                <h1>{{ 'SETTINGS.INFO' | translate }}</h1>
              </div>

              <div class="mail-container">
                <div>{{ 'SETTINGS.SUPPORT' | translate }}</div>
                <div>
                  <a href="mailto:kontakt@space-tech.it"
                    >kontakt&#64;space-tech.it</a
                  >
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
